/**
 * Personalise name bad-words matcher.
 * List source: shop metafield custom.list_of_the_bad_words (comma-separated).
 *
 * Matching rules:
 * - Case-insensitive ("Fuck", "fUck")
 * - Separators (- . ' spaces, etc.) split tokens ("man-fuck", "man.fuck", "man'fuck")
 * - Concatenated words without separators are allowed ("manfuck", "fuckman")
 */
window.PersonaliseBadWords = (function () {
  function parseList(source) {
    if (Array.isArray(source)) {
      return source.map(function (word) {
        return String(word).trim();
      }).filter(Boolean);
    }

    if (!source) return [];

    return String(source).split(',').map(function (word) {
      return word.trim();
    }).filter(Boolean);
  }

  var list = parseList(window.PERSONALISE_BAD_WORDS_LIST);

  function tokenize(value) {
    if (!value) return [];
    return String(value).toLowerCase().match(/[a-z0-9]+/g) || [];
  }

  function contains(text) {
    var tokens = tokenize(text);
    if (!tokens.length) return false;

    for (var i = 0; i < list.length; i++) {
      var phraseTokens = tokenize(list[i]);
      if (!phraseTokens.length || phraseTokens.length > tokens.length) continue;

      for (var start = 0; start <= tokens.length - phraseTokens.length; start++) {
        var matched = true;
        for (var j = 0; j < phraseTokens.length; j++) {
          if (tokens[start + j] !== phraseTokens[j]) {
            matched = false;
            break;
          }
        }
        if (matched) return true;
      }
    }

    return false;
  }

  function validateNameInput(input) {
    if (!input) return true;

    var hasBadWord = contains(input.value);
    input.classList.toggle('is-invalid', hasBadWord);
    input.setAttribute('aria-invalid', hasBadWord ? 'true' : 'false');
    return !hasBadWord;
  }

  return {
    list: list,
    contains: contains,
    validateNameInput: validateNameInput
  };
})();
